<template>
    <div v-if="feature_multilang == 'true'" class="locale-changer">
        <MultiSelect
            :id="localeChanger"
            v-model="selectedItem"
            name="locale"
            track-by="value"
            label="text"
            :searchable="false"
            :options="countries"
            select-label=""
            selected-label="*"
            deselect-label=""
            :disabled="readonly"
            aria-selected="true"
            :placeholder="selectedValue"
            @select="changeLocale"
        >
            <template slot="singleLabel" slot-scope="lang">
                <img
                    class="option__image"
                    :src="basePath + 'assets/images/selector.svg'"
                    :alt="lang.option.text"
                    height="25"
                />
                <span class="option__desc">
                    <span class="option__title text-uppercase fw-3">{{
                        lang.option.text + ' - ' + lang.option.value
                    }}</span>
                </span>
            </template>
            <template slot="option" slot-scope="lang">
                <div class="option__desc">
                    <span class="option__title text-uppercase fw-3">{{
                        lang.option.text + ' - ' + lang.option.value
                    }}</span>
                </div>
            </template>
        </MultiSelect>
    </div>
</template>

<script>
import languageOptions from '../../localization/lang/languageOptions'
import MultiSelect from 'vue-multiselect'
import helper from '../../utils/helper'

export default {
    name: 'LocaleChanger',
    components: {
        MultiSelect,
    },
    data() {
        return {
            countries: [...languageOptions].map((language) => {
                return {
                    value: language.locale,
                    text: language.text,
                }
            }),
            value: this.$locale,
            basePath: helper.getBaseAssetPath(),
            feature_multilang: process.env.VUE_APP_MULTILANG,
        }
    },
    computed: {
        selectedItem() {
            if (this.nonObjectModel) {
                return this.value
            }

            return this.countries.find((country) => country.value === this.value)
        },
    },
    methods: {
        changeLocale(selectedOption) {
            this.$locale = selectedOption.value
        },
    },
}
</script>

<style>
.locale-changer {
    cursor: pointer !important;
}
.multiselect__input,
.multiselect__single {
    line-height: unset !important;
    vertical-align: baseline !important;
}
.option__image {
    margin-bottom: 5px;
    margin-right: 5px;
}
.option__title {
    font-weight: 700;
}
</style>